<script>
	export default {
		name: 'MomentExecuter',
		methods: {
			addYear(dt, year) {
				const self_ = this;
				return self_.moment(dt).add(year, 'years')
			},
			addDay(dt, day) {
				const self_ = this;
				return self_.moment(dt).add(day, 'days')
			},
			formatTimestamp(ts, format) {
				const self_ = this;
				const dt_ = self_.convertTimestampToDate(ts)
				if(!format) { format = 'M/D/YYYY h:mm A' }
				return dt_.format(format)
			},
			formatDate(dt, format) {
				const self_ = this;
				if(!format) { format = 'M/D/YYYY h:mm A' }
				return self_.moment(dt).format(format)
			},
			convertTimestampToDate(ts) {
				const self_ = this;
				return self_.moment(new Date(ts.seconds * 1000))
			},
			diffDate(dtFrom, dtTo) { // dtFrom > dtTo
				const self_ = this;

				const from_ = self_.moment(dtFrom)
				const to_ = self_.moment(dtTo)

				return from_.diff(to_) // millisecond
			}
		}
	}
</script>	